import IMG from "../assets/coso.png";
import V1 from "../assets/1.mp4";
import V2 from "../assets/2.mp4";
import V3 from "../assets/3.mp4";
import Fondo from "../assets/videos.svg";

const Publicidad = () => {
    return (
        <div className="grid grid-cols-1 md:grid-cols-2 px-10 py-20 gap-10">
            <div className=" grid grid-cols-1 gap-10">
                <h1 className="text-4xl text-red-600 font-semibold">
                    Publicidad en Streaming
                </h1>
                <p>
                    Impulsa tu marca con nuestra publicidad en streaming.
                    Nuestras pantallas estratégicamente instaladas en puntos de alto tráfico aseguran que tu publicidad
                    llegue a la audiencia correcta en el momento perfecto.
                    <br/><br/>
                    Administra tu campaña, aumenta tu visibilidad, impulsa tus ventas y fortalece tu marca con nuestra ventaja competitiva.
                    Adaptamos nuestros servicios a tus necesidades específicas y te brindamos total control sobre la gestión de tu publicidad.
                    <br/><br/>
                    Sin importar el tamaño de tu empresa o el alcance de tus metas, estamos aquí para ayudarte a destacar.
                    <br/><br/>
                    Contáctanos hoy mismo y descubre cómo podemos llevar tu mensaje más allá de los límites tradicionales.
                    Nuestro objetivo es impulsar tu éxito y convertir tus objetivos en realidad.
                </p>
                <button className="w-64 p-4 bg-red-600 text-white rounded-full mx-auto shadow-lg">
                    Administra tu publicidad
                </button>
            </div>
            <div
                className="relative z-0 rounded-xl p-4 bg-no-repeat"
                style={{ backgroundImage: `url(${Fondo})` }}
            >
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 items-center">
                    <img src={IMG} alt="Publicidad" className="rounded-lg w-full h-auto" />
                    <video
                        src={V1}
                        className="rounded-lg w-full h-[180px] object-cover"
                        autoPlay
                        loop
                        muted
                        playsInline
                    />
                    <video
                        src={V2}
                        className="rounded-lg w-full h-[180px] object-cover"
                        autoPlay
                        loop
                        muted
                        playsInline
                    />
                    <video
                        src={V3}
                        className="rounded-lg w-full h-[33vh] object-cover"
                        autoPlay
                        loop
                        muted
                        playsInline
                    />
                </div>
            </div>
        </div>
    );
};

export default Publicidad;